import { render, staticRenderFns } from "./ArtworX.vue?vue&type=template&id=5632cf4c&scoped=true&"
import script from "./ArtworX.vue?vue&type=script&lang=ts&"
export * from "./ArtworX.vue?vue&type=script&lang=ts&"
import style0 from "./ArtworX.vue?vue&type=style&index=0&id=5632cf4c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632cf4c",
  null
  
)

export default component.exports